//components
import CityItem from './city-item';

//types
import {
    ColumnStructureItem,
    ColumnStructure,
    ColumnsStructure
} from '../types/ColumnStructureItem'

const CitiesColumns = (
    {
        columnsStructure,
        setCityWithRegion,
    }: {
        columnsStructure: ColumnsStructure,
        setCityWithRegion: (city: string, region: string) => void
    }
) => {
    return (
        <>
            {columnsStructure.map((column: ColumnStructure) => (
                <div className="cities-filter-list__column">
                    {column.map((columnItem: ColumnStructureItem) => (
                        <CityItem
                            city={columnItem?.city ?? ''}
                            isActive={false}
                            setCityHandler={() => setCityWithRegion(columnItem?.city ?? '', columnItem.region ?? '')}
                        />
                    ))}
                </div>
            ))}
        </>
    )
}

export default CitiesColumns;